// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___4Vdfg","container":"container___2ZGf4","button":"button___t6NHS","header":"header___3M8NZ","size":"size___1qWYb"};